(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fgfh-recording"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__fgfhReplaySetup || (window.Shopify && Shopify.designMode)) return;
  if (!/^(merch\.erindelia\.com|b20jxg-qa\.myshopify\.com)$/.test(location.hostname)) return;
  if (!/^\/$|^\/(products|collections|cart)(\/|$)/.test(location.pathname)) return;
  if (/[?&](email|token|key|password|code)=/i.test(location.search)) return;
  window.__fgfhReplaySetup = true;
  var mp, loading = false, active = false;
  var capture = {
    pageview: 'url-with-path', click: true, dead_click: true, rage_click: true,
    scroll: true, input: false, submit: false, capture_text_content: false,
    scroll_depth_percent_checkpoints: [25, 50, 75, 100],
    block_selectors: ['input', 'textarea', '[contenteditable="true"]', '.mp-sensitive', '.mp-no-track']
  };
  function allowed() {
    return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed());
  }
  function sync() {
    if (!allowed()) {
      if (mp) {
        mp.stop_session_recording();
        mp.set_config({autocapture: false, record_heatmap_data: false, record_sessions_percent: 0});
        mp.opt_out_tracking();
      }
      active = false;
      return;
    }
    if (!mp) { load(); return; }
    if (active) return;
    mp.opt_in_tracking({track: null});
    mp.register({tracking_source: 'FGFH storefront replay', tracking_version: '2026-09-16.1'});
    mp.set_config({autocapture: capture, record_heatmap_data: true, record_sessions_percent: 100});
    mp.start_session_recording();
    active = true;
  }
  function load() {
    if (loading) return;
    loading = true;
    (function(f,b){if(!b.__SV){var e,g,i,h;window.mixpanel=b;b._i=[];b.init=function(e,f,c){function g(a,d){var b=d.split('.');2==b.length&&((a=a[b[0]]),(d=b[1]));a[d]=function(){a.push([d].concat(Array.prototype.slice.call(arguments,0)));};}var a=b;'undefined'!==typeof c?(a=b[c]=[]):(c='mixpanel');a.people=a.people||[];a.toString=function(a){var d='mixpanel';'mixpanel'!==c&&(d+='.'+c);a||(d+=' (stub)');return d;};a.people.toString=function(){return a.toString(1)+'.people (stub)';};i='disable time_event track track_pageview track_links track_forms register register_once unregister identify set_config reset opt_in_tracking opt_out_tracking'.split(' ');for(h=0;h<i.length;h++)g(a,i[h]);b._i.push([e,f,c]);};b.__SV=1.2;e=f.createElement('script');e.type='text/javascript';e.async=true;e.src='https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';g=f.getElementsByTagName('script')[0];g.parentNode.insertBefore(e,g);}})(document,window.mixpanel||[]);
    window.mixpanel.init('0151128f3339e07f89639298190efe7e', {
      api_host: 'https://api.mixpanel.com',
      autocapture: false, record_sessions_percent: 0, record_heatmap_data: false,
      record_mask_all_text: true, record_mask_all_inputs: true,
      record_block_selector: 'img, video, iframe, input, textarea, [contenteditable="true"], .mp-sensitive, .mp-no-track',
      record_unmask_text_selector: 'header nav, main h1, main h2, main h3, main button',
      property_blacklist: ['$current_url', '$referrer', '$initial_referrer', 'current_url_search', '$current_url_search'],
      loaded: function(instance) { mp = instance; sync(); }
    }, 'fgfhReplay');
  }
  document.addEventListener('visitorConsentCollected', sync);
  function ready() {
    if (!window.Shopify) return;
    if (Shopify.customerPrivacy) { sync(); return; }
    if (Shopify.loadFeatures) {
      Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function(error) { if (!error) sync(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'toggle',
    function (e) {
      if (!e.target.classList.contains('filter-disclosure') && !e.target.classList.contains('sort-disclosure')) return;

      if (e.target.open) {
        document.body.setAttribute('data-scroll-locked', '');
      } else {
        // Unlock scroll only if no other filter is still open
        if (!document.querySelector('.filter-disclosure[open], .sort-disclosure[open]')) {
          document.body.removeAttribute('data-scroll-locked');
        }
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.localization-selector').forEach((details) => {
    document.addEventListener('click', (event) => {
      if (details.open && !details.contains(event.target)) {
        details.open = false;
      }
    });

    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        details.open = false;
        const summary = details.querySelector('summary');
        if (summary) summary.focus();
      }
    });

    details.addEventListener('toggle', () => {
      if (!details.open) return;
      const active = details.querySelector('[aria-current="true"]');
      if (active) {
        active.focus({ preventScroll: true });
        active.scrollIntoView({ block: 'nearest' });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
